export default {
  max: '',
  sum: '',
  count: '',
  layout: 'split', // tutors2
  digestibility: 0,

  lat2: '',
  lng2: '',

  login: {
    state: true
  },
  update: true,
  list: {
    lists: [
      {
        id: 1,
        name: 'vue.draggable',
        fixed: false,
        state: 1
      },
      {
        id: 2,
        name: 'draggable',
        fixed: false,
        state: 1
      },
      {
        id: 3,
        name: 'component',
        fixed: false,
        state: 1
      },
      {
        id: 4,
        name: 'for',
        fixed: false,
        state: 1
      },
      {
        id: 5,
        name: 'vue.js 2.0',
        fixed: false,
        state: 1
      },
      {
        id: 6,
        name: 'based',
        fixed: false,
        state: 1
      },
      {
        id: 7,
        name: 'on',
        fixed: false,
        state: 1
      },
      {
        id: 8,
        name: 'Sortablejs',
        fixed: false,
        state: 1
      },
      {
        id: 9,
        name: 'vue.draggable',
        fixed: false,
        state: 2
      },
      {
        id: 10,
        name: 'draggable',
        fixed: false,
        state: 2
      },
      {
        id: 11,
        name: 'component',
        fixed: false,
        state: 2
      },
      {
        id: 12,
        name: 'for',
        fixed: false,
        state: 2
      },
      {
        id: 13,
        name: 'vue.js 2.0',
        fixed: false,
        state: 2
      },
      {
        id: 14,
        name: 'based',
        fixed: false,
        state: 2
      },
      {
        id: 15,
        name: 'on',
        fixed: false,
        state: 2
      },
      {
        id: 16,
        name: 'Sortablejs',
        fixed: false,
        state: 2
      },
      {
        id: 17,
        name: 'vue.draggable',
        fixed: false,
        state: 3
      },
      {
        id: 18,
        name: 'draggable',
        fixed: false,
        state: 3
      },
      {
        id: 19,
        name: 'component',
        fixed: false,
        state: 3
      },
      {
        id: 20,
        name: 'for',
        fixed: false,
        state: 3
      },
      {
        id: 21,
        name: 'vue.js 2.0',
        fixed: false,
        state: 3
      },
      {
        id: 22,
        name: 'based',
        fixed: false,
        state: 3
      },
      {
        id: 23,
        name: 'on',
        fixed: false,
        state: 3
      },
      {
        id: 24,
        name: 'Sortablejs',
        fixed: false,
        state: 3
      },
      {
        id: 25,
        name: 'vue.draggable',
        fixed: false,
        state: 3
      },
      {
        id: 26,
        name: 'draggable',
        fixed: false,
        state: 4
      },
      {
        id: 27,
        name: 'component',
        fixed: false,
        state: 4
      },
      {
        id: 28,
        name: 'for',
        fixed: false,
        state: 4
      },
      {
        id: 29,
        name: 'vue.js 2.0',
        fixed: false,
        state: 4
      },
      {
        id: 30,
        name: 'based',
        fixed: false,
        state: 4
      },
      {
        id: 31,
        name: 'on',
        fixed: false,
        state: 4
      },
      {
        id: 32,
        name: 'Sortablejs',
        fixed: false,
        state: 5
      },
      {
        id: 33,
        name: 'vue.draggable',
        fixed: false,
        state: 5
      },
      {
        id: 34,
        name: 'draggable',
        fixed: false,
        state: 5
      },
      {
        id: 35,
        name: 'component',
        fixed: false,
        state: 5
      },
      {
        id: 36,
        name: 'for',
        fixed: false,
        state: 5
      },
      {
        id: 37,
        name: 'vue.js 2.0',
        fixed: false,
        state: 5
      },
      {
        id: 38,
        name: 'based',
        fixed: false,
        state: 5
      },
      {
        id: 39,
        name: 'on',
        fixed: false,
        state: 5
      },
      {
        id: 40,
        name: 'Sortablejs',
        fixed: false,
        state: 5
      },
      {
        id: 41,
        name: 'vue.draggable',
        fixed: false,
        state: 6
      },
      {
        id: 42,
        name: 'draggable',
        fixed: false,
        state: 6
      },
      {
        id: 43,
        name: 'component',
        fixed: false,
        state: 6
      },
      {
        id: 44,
        name: 'for',
        fixed: false,
        state: 6
      },
      {
        id: 45,
        name: 'vue.js 2.0',
        fixed: false,
        state: 6
      },
      {
        id: 46,
        name: 'based',
        fixed: false,
        state: 6
      },
      {
        id: 47,
        name: 'on',
        fixed: false,
        state: 6
      },
      {
        id: 48,
        name: 'Sortablejs',
        fixed: false,
        state: 6
      }
    ], // states

    banks: [],
    branches: [],

    versions: [],

    versionsAgreements: [],
    versionsAgreement: [],

    users: [],
    documents: [],
    companies: [],
    offices: [],
    prefs: [],
    families: [],
    familysupports: [],
    familyfiles: [],
    students: [],
    studentfiles: [],
    tutors: [],
    tutorsupports: [],
    tutorfiles: [],
    student_tutors: [],
    reports: [],
    tags: [],
    support_tags: [],
    channels: [],
    office_channels: [],
    appointment_channels: [],
    tutor_channels: [],
    appointments: [],

    nexts: [],

    todos: [],
    conditions: [],
    student_conditions: [],
    tutor_conditions: [],
    agreements: [],
    agreementsupports: [],
    advisors: [],

    contracts: [],
    paymentdetails: [],
    paymentdetails2s: [],

    paymentdetailsDelinquent_month: [],
    paymentdetailsDelinquent_two_month: [],
    paymentdetails2sDelinquent_month: [],
    paymentdetails2sDelinquent_two_month: []

  },
  item: {
    // version: {},
    user: {},
    document: {},
    company: {},
    office: {},
    pref: {},
    aggregate_appointment: {},
    aggregate_appointment_month: {},
    aggregate_appointment_month_comparison: {},
    aggregate_appointment_month2: {},
    aggregate_appointment_month2_comparison: {},
    aggregate_contract: {},
    aggregate_agreement: {},
    aggregate_contract_month: {},
    aggregate_paymentdetail: {},
    aggregate_tutor_channel: {},
    family: {
      familysupports: {
        support_tags: {
          tag: {}
        }
      },
      students: {},
      familyfiles: {}
    },
    student: {
      family: {
        familysupports: {
          support_tags: {
            tag: {}
          }
        },
        familyfiles: {}
      },
      student_tutors: {
        tutor: {}
      },
      studentfiles: {}
    },
    student_tutor: {},
    tutor: {
      tutorsupports: {
        support_tags: {
          tag: {}
        }
      },
      student_tutors: {
        student: {}
      },
      tutorfiles: {}
    },
    support_tag: {},
    familyfile: {},
    studentfile: {},
    tutorfile: {},
    report: {},
    channel: {},
    office_channel: {},
    appointment_channel: {},
    tutor_channel: {},
    appointment: {},
    todo: {},
    condition: {},
    student_condition: {},
    tutor_condition: {},
    agreement: {
      agreementsupports: {
        support_tags: {
          tag: {}
        }
      }
    },
    advisor: {},

    contract: {},
    paymentdetail: {},
    paymentdetails2: {}
  }
}



// WEBPACK FOOTER //
// ./src/store/state.js